// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get customer status package GET /api/v1/customer-status */
export async function customerStatusList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStatusListParams,
  options?: { [key: string]: any },
) {
  return request<API.CustomerStatusListDto>('/api/v1/customer-status', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Create customer status POST /api/v1/customer-status */
export async function customerStatusgeAdd(
  body: API.CreateCustomerStatusParamDto,
  options?: { [key: string]: any },
) {
  return request<API.CustomerStatus>('/api/v1/customer-status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Get customer status detail GET /api/v1/customer-status/${param0} */
export async function customerStatusDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStatusDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.CustomerStatus>(`/api/v1/customer-status/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Update customer status PUT /api/v1/customer-status/${param0} */
export async function customerStatusUpdate(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStatusUpdateParams,
  body: API.UpdateCustomerStatusParamDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.CustomerStatus>(`/api/v1/customer-status/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Delete customer status DELETE /api/v1/customer-status/${param0} */
export async function customerStatusDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStatusDeleteParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/customer-status/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Search status with customers POST /api/v1/customer-status/customers */
export async function listStatusWithCustomer(options?: { [key: string]: any }) {
  return request<API.CustomerStatusListWithCustomerDto>(
    '/api/v1/customer-status/customers',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** Change customer status status PATCH /api/v1/customer-status/status */
export async function customerStatusChangeStatus(
  body: API.ChangeManyStatusParamDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/customer-status/status', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
